import { type Command, TextSelection } from 'prosemirror-state'

import { isLockedPageBreak } from '#util/pagination/helpers'

/**
 * we manipulate multiblock selections that begin at the start of
 * a block and either encompass an entire single block or more than
 * one block so that cut/paste doesnt leave an orphaned empty block
 * of the same type with the same id behind.
 */
const extendSelection: Command = (viewState, viewDispatch) => {
  const { selection, doc, tr } = viewState
  const { $from, $to } = selection

  const isTextSelection = selection instanceof TextSelection
  /**
   * abort if any of the below are detected:
   * 1. plain cursor
   * 2. NodeSelection or AllSelection
   * 3. text selection that doesn't begin at the beginning of a block
   * 4. block is the first in the entire script
   * 5. block is a locked page boundary
   * */
  if (
    selection.empty ||
    !isTextSelection ||
    $from.parentOffset !== 0 ||
    $from.pos === 2 ||
    isLockedPageBreak($from.parent)
  ) {
    return false
  }

  const intraBlockSelection = $from.sameParent($to)
  const entireBlockSelection = $to.pos - $from.pos + 2 === $from.parent.nodeSize

  if (!intraBlockSelection || entireBlockSelection) {
    // move two positions to the outside edge of the previous block
    // do not pass go, do not collect $200
    const priorFrom = doc.resolve($from.pos - 2)
    tr.setSelection(new TextSelection(priorFrom, $to))
    viewDispatch?.(tr)
  }

  return false
}

export { extendSelection }
